<div class="module-timer-wrap">
  <p class="module-timer__instruction">
    You must remain in the {{ subject }} for at least {{ minStayDuration }}.
  </p>
  <div
    class="module-timer"
    [class.module-timer--complete]="timerComplete"
    role="timer"
    aria-live="off"
    [attr.aria-label]="timerComplete
      ? 'Minimum time met'
      : 'Time remaining to meet the minimum stay: ' + timerHours + ' hours ' + timerMinutes + ' minutes ' + timerSeconds + ' seconds'">
    <div class="module-timer__title">
      {{ timerComplete ? 'Minimum Time Met' : 'Time Remaining' }}
    </div>
    <div class="module-timer__clock" aria-hidden="true">
      <div class="module-timer__segment">
        <span class="module-timer__value">{{ timerHours }}</span>
        <span class="module-timer__label">HRS</span>
      </div>
      <span class="module-timer__colon">:</span>
      <div class="module-timer__segment">
        <span class="module-timer__value">{{ timerMinutes }}</span>
        <span class="module-timer__label">MIN</span>
      </div>
      <span class="module-timer__colon">:</span>
      <div class="module-timer__segment">
        <span class="module-timer__value">{{ timerSeconds }}</span>
        <span class="module-timer__label">SEC</span>
      </div>
    </div>
  </div>
</div>
